import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

function FeatureRow({ feature, index }) {
  const [ref, visible] = useScrollReveal(0.15);
  const reverse = index % 2 === 1;

  return (
    <div
      ref={ref}
      data-testid={`feature-row-${index}`}
      className={`flex flex-col gap-8 md:flex-row md:items-center ${
        reverse ? 'md:flex-row-reverse' : ''
      }`}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(28px)',
        transition: 'opacity 1s ease-out, transform 1s ease-out',
      }}
    >
      {/* Image */}
      <div className="image-zoom flex-1 overflow-hidden rounded-lg">
        <div className="relative aspect-[4/3]">
          <img
            src={feature.image}
            alt={feature.title}
            loading="lazy"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
        </div>
      </div>

      {/* Text */}
      <div className="flex-1 space-y-3 text-center md:text-start">
        <span className="text-xs font-semibold uppercase tracking-[0.3em] text-primary/60">
          {feature.num}
        </span>
        <h3 className="text-gradient-gold font-arabic text-2xl font-bold md:text-3xl leading-[1.6] pb-2">
          {feature.title}
        </h3>
        <p className="text-foreground/60">{feature.subtitle}</p>
      </div>
    </div>
  );
}

export default function Features({ t }) {
  return (
    <section className="py-16 md:py-24">
      <div className="container mx-auto max-w-5xl space-y-24 px-6 md:space-y-32">
        {t.features.map((feature, i) => (
          <FeatureRow key={i} feature={feature} index={i} />
        ))}
      </div>
    </section>
  );
}
